import React from 'react';
import styled from 'styled-components';
import { v4 } from 'uuid';
import { Icon, ScreenReaderOnly, TextBody } from '@ally/metronome-ui';
import { deprecated } from '@ally/metronome-icons';
import { passwordDirections, passwordV2Directions } from '../../validations';
const { muiCheckMark, muiClose } = deprecated;
const ContextualHelpWrapper = styled.ul `
  ${({ theme: { space } }) => `
    margin-top: ${space.md};
    padding-left: ${space.xxs};
  `}

  list-style-type: none;
  margin-bottom: 0px;
`;
const ContextualHelpRow = styled.li `
  display: flex;
  align-items: center;
`;
const SuccessTextBody = styled(TextBody) `
  ${({ theme: { colors } }) => `
    color: ${colors.success};
  `}
`;
const UnmetTextBody = styled(TextBody) `
  ${({ theme: { colors } }) => `
    color: ${colors['gray-700']};
  `}
`;
const IconWrapper = styled(Icon) `
  flex-shrink: 0;
`;
const PasswordContextualHelper = ({ password, shouldUseV2Validations = true, }) => {
    const directions = shouldUseV2Validations
        ? passwordV2Directions
        : passwordDirections;
    return (React.createElement(ContextualHelpWrapper, { "data-testid": "password-contextual-helper" }, directions.map((direction, index) => {
        const isSuccessful = direction.isValid(password || '');
        return (React.createElement(ContextualHelpRow, { key: v4() },
            isSuccessful ? (React.createElement(IconWrapper, { ariaHidden: true, icon: muiCheckMark, unsupportedCustomWidth: 10, unsupportedCustomHeight: 10, fill: "success", mr: "xs" })) : (React.createElement(IconWrapper, { ariaHidden: true, icon: muiClose, unsupportedCustomWidth: 10, unsupportedCustomHeight: 10, fill: "slate-400", mr: "xs" })),
            isSuccessful ? (React.createElement(SuccessTextBody, { tag: "p", size: "sm", "data-testid": `password-helper-direction-${index}-success` },
                direction.text,
                React.createElement(ScreenReaderOnly, null, ". You've met this requirement."))) : (React.createElement(UnmetTextBody, { tag: "p", size: "sm", "data-testid": `password-helper-direction-${index}-unmet` },
                direction.text,
                React.createElement(ScreenReaderOnly, null, ". You haven't met this requirement.")))));
    })));
};
export default PasswordContextualHelper;
//# sourceMappingURL=PasswordContextualHelper.js.map